import { render } from "./PixPaymentModal.vue?vue&type=template&id=2dd3758d&scoped=true"
import script from "./PixPaymentModal.vue?vue&type=script&lang=js"
export * from "./PixPaymentModal.vue?vue&type=script&lang=js"

import "./PixPaymentModal.vue?vue&type=style&index=0&id=2dd3758d&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd3758d"]])

export default __exports__